import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";

/**
 * Lightweight dropdown CTA. Items: [{ to, label, sublabel }]
 * Closes on outside click and on item click.
 */
const CTAMenu = ({ label, items, testId = "cta-menu" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="cta-menu" data-open={open} ref={ref} data-testid={testId}>
      <button
        type="button"
        className="cta-menu-btn"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid={`${testId}-button`}
      >
        {label}
        <ChevronDown size={14} className="chev" />
      </button>
      <div className="cta-menu-list" role="menu">
        {items.map((it, i) => (
          <Link
            key={it.to + i}
            to={it.to}
            onClick={() => setOpen(false)}
            data-testid={`${testId}-item-${i}`}
            role="menuitem"
          >
            <strong>{it.label}</strong>
            {it.sublabel && <span style={{ color: "rgba(13,31,36,.6)" }}>{it.sublabel}</span>}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CTAMenu;
